import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfSpec from '@elem/ui/ef-spec';
import EfXCore from '@elem/ui/ef-x-core';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('fourinone.teaser');
    const { locale } = useRouter();

    const itemA = {
        title: t('x_core_title'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1721198530784/x_core_bg.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1721198644677/x_core_bg_h5.jpg',
        btnText: t('x_core_btn'),
    };
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfXCore
                title={<EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722326378837/X-core.png" />}
                desc={itemA.title}
                btnLink={`https://www.ecoflow.com/${locale}/x-core-3`}
                btnText={itemA.btnText}
            />
        </div>
    );
}
